import { Stack } from '@mui/material';
import { UsedInOfflineMode } from '../../../../../offline/types/UsedInOfflineMode';
import { hasSplit } from '../../../../conditions/orderCondition.utils';
import { Order } from '../../../../order.types';
import OrderObjectGeneralDataSection from './components/OrderObjectGeneralDataSection/OrderObjectGeneralDataSection';
import OrderObjectSplitsSection from './components/OrderObjectSplitsSection/OrderObjectSplitsSection';
import OrderObjectSummarySection from './components/OrderObjectSummarySection';

interface OrderObjectDetailsSectionsProps extends UsedInOfflineMode {
  order: Order;
  isReadOnlyView: boolean;
}

const OrderObjectDetailsSections = ({
  order,
  isReadOnlyView,
  isOfflineMode,
}: OrderObjectDetailsSectionsProps) => (
  <Stack sx={{ gap: 1.5 }}>
    <OrderObjectGeneralDataSection
      order={order}
      isReadOnlyView={isReadOnlyView}
      isOfflineMode={isOfflineMode}
    />
    {!isReadOnlyView && !isOfflineMode && hasSplit(order.splitSettings) && (
      <OrderObjectSplitsSection />
    )}
    <OrderObjectSummarySection isReadOnlyView={isReadOnlyView} />
  </Stack>
);

export default OrderObjectDetailsSections;
